import { MS_API_BACKEND_URL } from "../settings";
import { api } from "./api";

class PurchaseSupplyConfigService {
  constructor() {
    this.url = MS_API_BACKEND_URL;
    this.basePath = `${this.url}/api/purchase-supply/v1/product-purchase-config`;
  }

  async getAll(params) {
    const { data } = await api.get(this.basePath, { params });
    return {
      data: {
        results: data?.results || [],
        total_count:
          data?.total_count ??
          data?.totalCount ??
          data?.count ??
          (data?.results ? data.results.length : 0)
      }
    };
  }

  async create(payload) {
    return await api.post(this.basePath, payload);
  }

  async update(id, payload) {
    return await api.patch(`${this.basePath}/${id}`, payload);
  }

  async remove(id) {
    return await api.delete(`${this.basePath}/${id}`);
  }
}

const purchaseSupplyConfigService = new PurchaseSupplyConfigService();
export default purchaseSupplyConfigService;
